import React from 'react';
import {Col, Row} from "react-grid-system";
import StepNav from "../../../../components/step-nav";
import Field from "../../../../containers/form/field";
import Form from "../../../../containers/form/form";
import Button from "../../../../components/ui/button";
import {useSettingsStore} from "../../../../store";
import {get} from "lodash"
import Title from "../../../../components/ui/title";
import {useTranslation} from "react-i18next";
import {usePostQuery, usePutQuery} from "../../../../hooks/api";
import {AGREEMENT_CREATE_STEPS} from "../../utils/agreementSteps";
import {buildAgreementSaveAttributes, getAgreementPatchUrl} from "../../utils/agreementEditHydration";
import {KEYS} from "../../../../constants/key";
import {URLS} from "../../../../constants/url";
import {OverlayLoader} from "../../../../components/loader";
import {useNavigate} from "react-router-dom";

const StepFour = ({id = null, ...props}) => {
    const navigate = useNavigate()
    const {t} = useTranslation()

    const {mutate: createAgreement, isLoading: isCreating} = usePostQuery({listKeyId: KEYS.agreements})
    const {mutate: updateAgreement, isLoading: isUpdating} = usePutQuery({listKeyId: KEYS.agreements})

    const setAgreement = useSettingsStore(state => get(state, 'setAgreement', () => {
    }))
    const resetAgreement = useSettingsStore(state => get(state, 'resetAgreement', () => {
    }))

    const agreement = useSettingsStore(state => get(state, 'agreement', {}))
    const insurer = useSettingsStore(state => get(state, 'insurer', {}))
    const commissions = useSettingsStore(state => get(state, 'commissions', []))
    const isLoading = isCreating || isUpdating

    const nextStep = ({data}) => {
        if (id) {
            const agreementId = id || get(agreement, '_id');
            setAgreement(data);
            const attributes = buildAgreementSaveAttributes(agreement, data, {
                commissions,
                insurer,
            });
            updateAgreement({
                url: getAgreementPatchUrl(agreementId),
                attributes,
            }, {
                onSuccess: () => {
                    resetAgreement();
                    navigate('/agreements');
                },
            });
            return;
        }
        const {product, ...rest} = agreement
        createAgreement({url: URLS.agreements, attributes: {...rest, ...data, product: get(product, '_id')}}, {
            onSuccess: () => {
                resetAgreement();
                navigate('/agreements')
            },
            onError: () => {

            }
        })
    }

    const prevStep = () => {
        props.previousStep();
    }

    const reset = () => {
        resetAgreement();
        props.firstStep();
    }
    
    return (
        <Row>
            {(isLoading) && <OverlayLoader/>}
            <Col xs={12}>
                <StepNav step={4} steps={AGREEMENT_CREATE_STEPS}/>
            </Col>
            <Col xs={12}>
                <Form formRequest={nextStep} key={id ? get(agreement, '_id') : 'create-step-four'}>
                    <Row className={'mb-15'}>
                        <Col xs={12}>
                            <Title>{t("Анкета заявления")}</Title>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={3}>
                            <Field
                                name={`registrationNumber`}
                                type={'input'}
                                label={t("Номер регистрации")}
                                defaultValue={get(agreement, 'registrationNumber')}
                            />
                        </Col>
                        <Col xs={3}>
                            <Field property={{minDate:new Date()}} params={{required:true}} name={'applicationDate'} type={'datepicker'}
                                   label={t("Дата заявления")}
                                   defaultValue={get(agreement, 'applicationDate')}
                            />
                        </Col>
                        <Col xs={3}>
                            <Field
                                name={`whoAccepted`}
                                type={'input'}
                                label={t("Кем принято")}
                                defaultValue={get(agreement, 'whoAccepted')}
                            />
                        </Col>
                        <Col xs={3}>
                            <Field
                                name={`copyOfDocuments`}
                                type={'dropzone'}
                                label={t("Скан копии документов")}
                                defaultValue={get(agreement, 'copyOfDocuments')}
                            />
                        </Col>

                    </Row>

                    <Row className={'mb-15'}>
                        <Col xs={12}>
                            <Title>{t("Договор")}</Title>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={3}>
                            <Field
                                label={t('Генеральный договор')}
                                type={'switch'}
                                name={'hasGeneralAgreement'}
                                params={{required: true}}
                                defaultValue={!!get(agreement, 'hasGeneralAgreement')}
                            />
                        </Col>
                        <Col xs={3}>
                            <Field
                                name={`copyOfAgreement`}
                                type={'dropzone'}
                                label={t("Скан копии договоров")}
                                defaultValue={get(agreement, 'copyOfAgreement')}
                            />
                        </Col>
                    </Row>
                    <Row className={'mb-15'}>
                        <Col xs={12}>
                            <Title>{t("Приложения")}</Title>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={3}>
                            <Field
                                name={`documents`}
                                type={'dropzone'}
                                label={t("Скан копии документов")}
                                defaultValue={get(agreement, 'documents')}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} className={'mt-32'}>
                            <Button className={'mr-16'} type={'button'} onClick={reset} danger outlined
                                    back>{t("Отменить")}</Button>
                            <Button dark className={'mr-16'} type={'button'} onClick={prevStep}
                                    outlined>{t("Назад")}</Button>
                            <Button type={'submit'} success>{t("Подтвердить")}</Button>
                        </Col>
                    </Row>
                </Form>

            </Col>
        </Row>
    );
};

export default StepFour;